import React, { useEffect, memo } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import * as yup from 'yup'

import Button from 'components/CommonUI/Button/Button'
import Title from './Title'
import TextInput from 'components/CommonUI/TextInput/TextInput'
import {
  changePassword,
  getErrorRestoreTypeSelector,
  getIsSuccessResporePassword,
} from 'redux/reducers/profile'
import { useShallowEqualSelector } from 'custom-hooks'

let schema = yup.object().shape({
  newPassword: yup
    .string()
    .required('Password field is required')
    .matches(
      /^[\S]+.*[\S]+$/,
      "Password can't start or end the space character"
    )
    .min(8, 'Password must be at least 8 characters')
    .max(20),

  confirmNewPassword: yup
    .string()
    .oneOf([yup.ref('newPassword'), null], 'Confirmation password must match')
    .required('Confirmation password is required'),
})

const ComfirmRestorePassword = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const errorType = useShallowEqualSelector(getErrorRestoreTypeSelector)
  const isSuccessRestorePassword = useShallowEqualSelector(
    getIsSuccessResporePassword
  )

  const _code = history.location.state?.confirmCode
  const _userName = history.location.state?.userName

  const formik = useFormik({
    initialValues: {
      newPassword: '',
      confirmNewPassword: '',
    },
    onSubmit: (values) => {
      dispatch(
        changePassword({
          password: values.newPassword,
          code: _code,
          userName: _userName,
        })
      )
    },
    validationSchema: schema,
    validateOnBlur: true,
    validateOnChange: false,
  })

  useEffect(() => {
    if (errorType) {
      history.push('/auth/error-restore-password', { userEmail: _userName })
    }
  }, [_userName, errorType, history])

  useEffect(() => {
    if (isSuccessRestorePassword) {
      history.push('/auth/success-restore-password')
    }
  }, [history, isSuccessRestorePassword])

  useEffect(() => {
    if (!formik.values.newPassword && formik.touched.newPassword) {
      formik.setFieldTouched('newPassword', false)
    }
    if (
      !formik.values.confirmNewPassword &&
      formik.touched.confirmNewPassword
    ) {
      formik.setFieldTouched('confirmNewPassword', false)
    }
  }, [formik])

  useEffect(() => {
    if (!_code || !_userName) {
      history.push('/')
    }
  }, [_code, _userName, history])

  return (
    <>
      <Title content="Change password" />
      <Title
        content="Create a new, strong password that you don’t use for other websites"
        type="subtitle"
      />
      <form onSubmit={formik.handleSubmit} name={'new_password_form'}>
        <TextInput
          placeholder="Create password"
          styleType="dark"
          classNameContainer="auth_login_form_input"
          mb={35}
          value={formik.values.newPassword}
          onChange={formik.handleChange}
          name="newPassword"
          errorMessage={
            (!!formik.values.newPassword &&
              formik.touched.newPassword &&
              formik.errors.newPassword) ||
            (formik.submitCount && formik.errors.newPassword)
          }
          type="password"
          autoComplete="new-password"
          onBlur={formik.handleBlur}
        />
        <TextInput
          placeholder="Confirm password"
          styleType="dark"
          classNameContainer="auth_login_forml_input"
          mb={35}
          type="password"
          value={formik.values.confirmNewPassword}
          onChange={formik.handleChange}
          name="confirmNewPassword"
          errorMessage={
            (!!formik.values.confirmNewPassword &&
              formik.touched.confirmNewPassword &&
              formik.errors.confirmNewPassword) ||
            (formik.submitCount && formik.errors.confirmNewPassword)
          }
          autoComplete="new-password"
          onBlur={formik.handleBlur}
        />
        <Button className="auth_login_forml_button" mb={16} type="submit">
          Save password
        </Button>
      </form>
    </>
  )
}

export default memo(ComfirmRestorePassword)
